import Vue from "vue";
import VueAnalytics from "vue-analytics";
import Router from "vue-router";
import Inicio from "@/pages/Inicio";
import FichaCarreraTP from "@/pages/BuscadoresTP/FichaCarreraTP";
import FichaInstitucion from "@/pages/BuscadoresTP/FichaInstitucion";
import BuscadorTP from "@/pages/BuscadoresTP/BuscadorTP";
import BuscadorIP from "@/pages/BuscadoresTP/BuscadorIP";
import BuscadorCU from "@/pages/BuscadoresU/BuscadorCU";
import BuscadorInstU from "@/pages/BuscadoresU/BuscadorInst";
import FichaInstitutoU from "@/pages/BuscadoresU/FichaInstitutoU";
import FichaCarreraU from "@/pages/BuscadoresU/FichaCarreraU";
import SimuladorPonderaciones from "@/pages/SimuladorPonderaciones";
import ComparadorITP from "@/pages/BuscadoresTP/ComparadorITP";
Vue.use(Router);

const router = new Router({
  base: CONTEXT,
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Inicio",
      component: Inicio
    },
    {
      path: "/buscador-ctp",
      name: "BuscadorTP",
      component: BuscadorTP
    },
    {
      path: "/buscador-itp",
      name: "BuscadorIP",
      component: BuscadorIP
    },
    {
      path: "/buscador-cu",
      name: "BuscadorCU",
      component: BuscadorCU
    },
    {
      path: "/buscador-iu",
      name: "BuscadorInstU",
      component: BuscadorInstU
    },
    {
      path: "/comparador-itp",
      name: "ComparadorITP",
      component: ComparadorITP
    },
    {
      path: "/institucion/:idInstitucion/carrera/:codigoCarrera",
      name: "FichaCarrera",
      component: FichaCarreraTP
    },
    {
      path: "/universidad/:idInstitucion/carrera/:codigoCarrera",
      name: "FichaCarreraU",
      component: FichaCarreraU
    },
    {
      path: "/institucion/:idInstitucion",
      name: "FichaInstitucion",
      component: FichaInstitucion
    },
    {
      path: "/universidad/:idInstitucion",
      name: "FichaInstitutoU",
      component: FichaInstitutoU
    },
    {
      path: "/simulador-pond",
      name: "SimuladorPonderaciones",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.HOME;
      }
    },
    {
      path: "/portal-admision-subsistema-tecnico-profesional/",
      name: "AdmisionTP",
      beforeEnter() {
        location.href = PLATAFORMA_TP.ADMISIONTP;
      }
    },
    {
      path: "/ficha-de-caracterizacion-unica-tecnico-profesional/",
      name: "FCU",
      beforeEnter() {
        location.href = PLATAFORMA_TP.FCU;
      }
    },
    {
      path: "/reglamento-subsistema-tecnico-profesional",
      name: "ReglamentoTP",
      beforeEnter() {
        location.href = PLATAFORMA_TP.REGLAMENTO;
      }
    },
    {
      path: "/calendario-proceso-postulacion-y-admision-educacion-superior",
      name: "CalendarioTP",
      beforeEnter() {
        location.href = PLATAFORMA_TP.CALENDARIO;
      }
    },
    {
      path: "/elige-ser-tp",
      name: "EligeSerTP",
      beforeEnter() {
        location.href = PLATAFORMA_TP.ELIGE_TP;
      }
    },
    {
      path: "/reglamento-subsistema-universitario",
      name: "ReglamentoU",
      beforeEnter() {
        location.href = PLATAFORMA_U.REGLAMENTO;
      }
    },
    {
      path: "/material-de-preparacion-paes",
      name: "MaterialPreparacionU",
      beforeEnter() {
        location.href = PLATAFORMA_U.MATERIAL_PREPARACION;
      }
    },
    {
      path: "/calendario-proceso-postulacion-y-admision-educacion-superior",
      name: "CalendarioU",
      beforeEnter() {
        location.href = PLATAFORMA_U.CALENDARIO;
      }
    },
    {
      path: "/portal-pedagogias",
      name: "Pedagogias",
      beforeEnter() {
        location.href = PLATAFORMA_U.PEDAGOGIAS;
      }
    },
    {
      path: "/admision-universidades-2023",
      name: "AdmisionU",
      beforeEnter() {
        location.href = PLATAFORMA_U.ADMISION_UNIVERSIDADES;
      }
    },
    {
      path: "/home",
      name: "Home",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.HOME;
      }
    },
    {
      path: "/beneficios-estudiantiles",
      name: "BeneficiosEstudiantiles",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.BENEFICIOS_ESTUDIANTILES;
      }
    },
    {
      path: "/acreditacion",
      name: "Acreditacion",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.ACREDITACION;
      }
    },
    {
      path: "/sistema",
      name: "Sistema",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.SISTEMA;
      }
    },
    {
      path: "/instituciones",
      name: "Instituciones",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.INSTITUCIONES;
      }
    },
    {
      path: "/comites-deacceso",
      name: "Comite",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.COMITE;
      }
    },
    {
      path: "/prueba-de-transicion",
      name: "PruebaTransicion",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PRUEBA_TRANSICION;
      }
    },
    {
      path: "/sitios",
      name: "SitiosDestacados",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.SITIOS_DESTACADOS;
      }
    },
    {
      path: "/noticias",
      name: "Noticias",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.NOTICIAS;
      }
    },
    {
      path: "/fechas",
      name: "Fechas",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.FECHAS;
      }
    },
    {
      path: "/terminos",
      name: "TerminosCondiciones",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.TERMINOS_Y_CONDICIONES;
      }
    },
    {
      path: "/vias-especiales",
      name: "ViasEspeciales",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.VIAS_ESPECIALES;
      }
    },
    {
      path: "/accesouniversidades2023",
      name: "AccesoUniversidades",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.ACCESO_UNIVERSIDADES;
      }
    },
    {
      path: "/paes",
      name: "Paes",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PAES;
      }
    },
    {
      path: "/portal-para-estudiantes-extranjeras-y-extranjeros",
      name: "PortalExtranjeros",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.EXTRANJEROS;
      }
    },
    {
      path: "/portal-pace",
      name: "PortalPace",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PORTAL_PACE;
      }
    },
    {
      path: "/programas-de-acceso-a-las-pedagogias",
      name: "ProgramaPedagogias",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PROGRAMA_PEDAGOGIAS;
      }
    },
    {
      path: "/admision-regular",
      name: "AdmisionRegular",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.ADMISION_REGULAR;
      }
    },
    {
      path: "/cupos-beca-excelencia-academicabea",
      name: "CuposBea",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.CUPOSBEA;
      }
    },
    {
      path: "/cupos-mas-mujeres-cientificas-mc",
      name: "MasMujeresCientificas",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.MASMUJERESCIENTIFICAS;
      }
    },
    {
      path: "/admision-especial",
      name: "AdmisionEspecial",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.ADMISION_ESPECIAL;
      }
    },
    {
      path: "/paes-invierno",
      name: "PaesInvierno",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PAES_INVIERNO;
      }
    },
    {
      path: "/paes-regular",
      name: "PaesRegular",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PAES_REGULAR;
      }
    },
    {
      path: "/portal-pedagogias",
      name: "PortalPegagias",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PORTALPEDAGOGIAS;
      }
    },
    {
      path: "/distinciones-trayectorias",
      name: "DistincionesTrayectorias",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.DISTINCIONESTRAYECTORIAS;
      }
    },
    {
      path: "/preguntas-frecuentes/admision-tecnico-profesional",
      name: "PreguntasAdmisionTP",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PREGUNTAS_FRECUENTES.ADMISION_TP;
      }
    },
    {
      path: "/preguntas-frecuentes/admision-universidades",
      name: "PreguntasAdmisionU",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PREGUNTAS_FRECUENTES.ADMISION_U;
      }
    },
    {
      path: "/preguntas-frecuentes/informacion-general-paes",
      name: "PreguntasInformacionPAES",
      beforeEnter() {
        location.href =
          PLATAFORMA_GENERAL.PREGUNTAS_FRECUENTES.INFORMACION_PAES;
      }
    },
    {
      path: "/preguntas-frecuentes/admision-pedagogias",
      name: "PreguntasPedagogias",
      beforeEnter() {
        location.href =
          PLATAFORMA_GENERAL.PREGUNTAS_FRECUENTES.ADMISION_PEDAGOGIA;
      }
    },
    {
      path:
        "/preguntas-frecuentes/programa-de-acceso-a-la-educacion-superior-pace",
      name: "PreguntasProgramaPACE",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PREGUNTAS_FRECUENTES.PROGRAMA_PACE;
      }
    },
    {
      path: "/preguntas-frecuentes/sistema-de-acceso-a-educacion-superior",
      name: "PreguntasSistemaAcceso",
      beforeEnter() {
        location.href = PLATAFORMA_GENERAL.PREGUNTAS_FRECUENTES.SISTEMA_ACCESO;
      }
    },
    {
      path: "*",
      component: Inicio
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
Vue.use(VueAnalytics, {
  id: "UA-6059648-21",
  router
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js